wbApp.factory('employeeAvailabilitySchedulesSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {
        var AvailabilitySchedule = $resource('/restapi/employees/:employeeId/availability-schedules/:id', {}, {
            'getRange': { method: 'GET', isArray: true, url: '/restapi/employees/:employeeId/availability-schedules/range' },
            'updateRange': { method: 'PUT', url: '/restapi/employees/:employeeId/availability-schedules/range' }
        });

        function loadWeek(employeeId, date) {
            return $q(function (resolve, reject) {

                var startOfWeek = moment(date).startOf('isoWeek');
                var endOfWeek = moment(date).endOf('isoWeek').startOf('day');

                repositorySvc.customGet('getRange', AvailabilitySchedule, {
                    employeeId: employeeId,
                    from: startOfWeek.toDate(),
                    to: endOfWeek.toDate(),
                }, function (data) {
                        var result = [];
                        for (var i = 0; i < 7; i++) {
                            var dayData = _.find(data, function (d) {
                                return moment(d.day).isSame(startOfWeek);
                            });
                            if (dayData) {
                                result.push(dayData);
                            } else {
                                result.push({ day: startOfWeek.toDate(), periods: [] });
                            }
                            startOfWeek.add(1, 'day');
                        }
                        resolve(result);
                    },
                    function (error) {
                        reject(error);
                    }
                );
            });
        }

        function saveWeek(employeeId, date, model) {
            return $q(function (resolve, reject) {

                var startOfWeek = moment(date).startOf('isoWeek');
                var endOfWeek = moment(date).endOf('isoWeek').startOf('day');

                var filtered = _.filter(model, function (d) { return !!d.periods && d.periods.length > 0; });

                repositorySvc.customPutWithParams(
                    'updateRange', 
                    AvailabilitySchedule,
                    {
                        employeeId: employeeId,
                        from: startOfWeek.toDate(),
                        to: endOfWeek.toDate()
                    },
                    filtered,
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(repositorySvc.extractErrorData(error));
                    }
                );
            });
        }

        function saveWeekAsPaternForPeriod(employeeId, periodStart, periodEnd, weekModelTemplate) 
        {
            return $q(function (resolve, reject) {
                var startOfWeekPeriod = moment(periodStart).startOf('isoWeek');
                var endOfWeekPeriod = moment(periodEnd).endOf('isoWeek').startOf('day');

                var filtered = _.filter(weekModelTemplate, function (d) { return !!d.periods && d.periods.length > 0; });

                var currentPeriod = moment(startOfWeekPeriod);
                var toSave = [];
                while (currentPeriod.isBefore(endOfWeekPeriod)) {

                    if (filtered.length > 0) {
                        var templateCopy = angular.copy(filtered);
                        var timeDifference = moment.duration(currentPeriod.diff(moment(templateCopy[0].day).startOf('week')));

                        _.forEach(templateCopy, function (d) {
                            d.day = moment(d.day).add(timeDifference).toDate();
                            _.forEach(d.periods, function (p) {
                                p.start = moment(p.start).add(timeDifference).toDate();
                                p.end = moment(p.end).add(timeDifference).toDate();
                            });

                            toSave.push(d);
                        });
                    }

                    currentPeriod.add(1, 'week');                    
                }

                repositorySvc.customPutWithParams(
                    'updateRange',
                    AvailabilitySchedule,
                    {
                        employeeId: employeeId,
                        from: startOfWeekPeriod.toDate(),
                        to: endOfWeekPeriod.toDate()
                    },
                    toSave,
                    function (data) {
                        resolve(data);
                    },
                    function (error) {
                        reject(repositorySvc.extractErrorData(error));
                    }
                );
            });
        }

        return {
            loadWeek: loadWeek,
            saveWeek: saveWeek,
            saveWeekAsPaternForPeriod: saveWeekAsPaternForPeriod
        }
    }]);